<template>
  <v-card outlined class="rounded-lg">
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="categories"
        hide-default-footer
        disable-pagination
        class="elevation-0"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>LLM Stats Categories Config</v-toolbar-title>
          </v-toolbar>
        </template>
        <template v-slot:item.show="{ item }">
          <v-tooltip v-if="item.show" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="green"
                v-bind="attrs"
                v-on="on"
                @click="updateCategory({ ...item, show: false })"
              >
                <v-icon>
                  {{ mdiEye }}
                </v-icon>
              </v-btn>
            </template>
            <span>Category shown</span>
          </v-tooltip>
          <v-tooltip v-else bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="red"
                v-bind="attrs"
                v-on="on"
                @click="updateCategory({ ...item, show: true })"
              >
                <v-icon>
                  {{ mdiEyeOff }}
                </v-icon>
              </v-btn>
            </template>
            <span>Category hidden</span>
          </v-tooltip>
        </template>
        <template v-slot:item.use_in_charts="{ item }">
          <v-simple-checkbox
            color="primary"
            :value="!!item.use_in_charts"
            @input="event => updateCategory({ ...item, use_in_charts: event })"
          />
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mdiEye, mdiEyeOff } from "@mdi/js"
export default {
  data () {
    return {
      mdiEye,
      mdiEyeOff,
      categories: [],
      headers: [
        {
          text: 'Name',
          value: 'name',
          sortable: false,
        },
        {
          text: 'Show',
          value: 'show',
          sortable: false,
        },
        {
          text: 'Use in Charts',
          value: 'use_in_charts',
          align: 'center',
          sortable: false,
        }
      ]
    }
  },
  async created() {
    const { data } = await this.$axios.get(this.$store.getters.projectPath + '/llm-stats-categories')
    .catch(error => ({ data: { err: true, message: error.response.data } }))

    if (data.err) {
      this.$toasted.error(data.message)
    } else {
      this.categories = data;
    }
  },
  methods: {
    async updateCategory (item) {
      const { data } = await this.$axios.put(this.$store.getters.projectPath + '/llm-stats-categories/' + item.id, item)
      .catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        const index = this.categories.findIndex(category => category.id === data.id)
        this.$set(this.categories, index, data)
      }
    }
  }
}
</script>